<template>
    <div style="background: none transparent;">
        <stream-details v-if="streamType==='detail4' || streamType==='detail1or2' "
                        class="scale" :style="scaleStyle">
        </stream-details>
        <stream-total v-else-if="streamType==='total'"
                      class="scale" :style="scaleStyleTotal">
        </stream-total>
    </div>
</template>

<script>
    import StreamDetails from "./streamDetails";
    import StreamTotal from "./streamTotal";

    export default {
        components: {
            StreamTotal,
            StreamDetails,},
        name: "stream",
        computed: {
            streamType(){
                return this.$route.query.type;
            },
            scaleRatio(){
                return this.breite / 1920
            },
            scaleRatioTotal(){
                return this.breite / 1670
            },
            scaleStyle(){
                return 'transform: scale(' + this.scaleRatio + ');'
            },
            scaleStyleTotal(){
                return 'transform: scale(' + this.scaleRatioTotal + ');'
            }
        },
        data: () => ({
            breite: window.innerWidth,
        }),
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        methods: {
            onResize() {this.breite = window.innerWidth},
        },
    }
</script>

<style scoped>
    .scale {
        transform-origin: left top;
    }
</style>